import { call, put, takeLatest } from "@redux-saga/core/effects";
import * as action from "./reducer";
import { axiosInstance } from "../constant";
import toast from "react-hot-toast";

// var baseUrl = "http://localhost:3001/api";
var baseUrl = process.env.REACT_APP_API_URL;

// Function to get current language (adjust according to your setup)
const getCurrentLanguage = () =>
  sessionStorage.getItem("preferredLanguage") || "ar";

// Messages in Arabic & English
const messages = {
  loginSuccess: {
    en: "Login Success!",
    ar: "تم تسجيل الدخول بنجاح!",
  },
  invalidUser: {
    en: "Invalid User",
    ar: "مستخدم غير صالح",
  },
  invalidUsername: {
    en: "Invalid Username",
    ar: "اسم مستخدم غير صالح",
  },
  wrongCredentials: {
    en: "Wrong Credentials!",
    ar: "بيانات اعتماد خاطئة!",
  },
  networkError: {
    en: "Network Error! Please check your internet connection.",
    ar: "خطأ في الشبكة! يرجى التحقق من اتصالك بالإنترنت.",
  },
  badRequest: {
    en: "Bad Request!",
    ar: "طلب غير صالح!",
  },
  invalidCredentials: {
    en: "Invalid email or password!",
    ar: "البريد الإلكتروني أو كلمة المرور غير صحيحة!",
  },
  forbidden: {
    en: "You do not have permission to access this resource!",
    ar: "ليس لديك إذن للوصول إلى هذا المورد!",
  },
  notFound: {
    en: "Resource not found!",
    ar: "المورد غير موجود!",
  },
  serverError: {
    en: "Internal Server Error! Please try again later.",
    ar: "خطأ في الخادم الداخلي! يرجى المحاولة لاحقًا.",
  },
  unexpectedError: {
    en: "An unexpected error occurred!",
    ar: "حدث خطأ غير متوقع!",
  },
};

function* UserLogin({ payload }) {
  try {
    yield put(action.Loading({ Loading: true }));

    const response = yield call(
      axiosInstance.post,
      baseUrl + `/auth/login`,
      payload
    );

    const lang = getCurrentLanguage();

    if (
      (response?.data?.results?.role === "admin" ||
        response?.data?.results?.role === "moderator") &&
      response?.data?.results?.accessToken
    ) {
      const temp = {
        user: response.data?.results,
        islogin: true,
        role: response?.data?.results?.role,
      };
      yield put(action.Auth(temp));
      sessionStorage.setItem("user", JSON.stringify(temp));
      toast.success(messages.loginSuccess[lang]);
    } else {
      toast.error(messages.invalidUser[lang]);
    }
  } catch (error) {
    const lang = getCurrentLanguage();

    if (!error.response) {
      toast.error(messages.networkError[lang]);
    } else {
      const { status, data } = error.response;
      let errorMessage = messages.unexpectedError[lang];

      // Handle specific error messages from the backend
      if (data?.message === "Invalid Username") {
        errorMessage = messages.invalidUsername[lang];
      } else if (data?.message === "Wrong Credentials") {
        errorMessage = messages.wrongCredentials[lang];
      } else {
        switch (status) {
          case 400:
            errorMessage = data.message || messages.badRequest[lang];
            break;
          case 401:
            errorMessage = messages.invalidCredentials[lang];
            break;
          case 403:
            errorMessage = messages.forbidden[lang];
            break;
          case 404:
            errorMessage = messages.notFound[lang];
            break;
          case 500:
            errorMessage = messages.serverError[lang];
            break;
          default:
            errorMessage = data.message || errorMessage;
        }
      }

      toast.error(errorMessage);
    }
  } finally {
    yield put(action.Loading({ Loading: false }));
  }
}

export default function* HomeSaga() {
  yield takeLatest("LOGIN_USER", UserLogin);
}
